module.exports = __webpack_public_path__ + "img/baby-face-brow.ea6fda74.png";